import { Routes } from '@angular/router';
import { GraphOutputComponent } from './components/graph-output/graph-output.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { Normal_mode_dashboardComponent } from './components/normal_mode_dashboard/normal_mode_dashboard.component';
import { Normal_mode_outputComponent } from './components/normal_mode_output/normal_mode_output.component';
import { PopUpComponent } from './components/pop-up/pop-up.component';
import { ExploreModeOutputComponent } from './components/explore-mode-output/explore-mode-output.component';
import { canActivateAuthRole } from '../../../auth/src/public-api';
import { LandingPageComponent } from './components/landing-page/landing-page.component';

export const routes: Routes = [
    { path: 'home', component: HomeComponent,canActivate: [canActivateAuthRole], },
    { path: 'normal-output', component: Normal_mode_outputComponent,canActivate: [canActivateAuthRole] },
    { path: 'normal-dash-output', component: Normal_mode_dashboardComponent,canActivate: [canActivateAuthRole] },
    { path: '', component: LandingPageComponent,canActivate: [canActivateAuthRole] },
    { path: 'login', component: LoginComponent },
    { path: 'explore-output', component: ExploreModeOutputComponent,canActivate: [canActivateAuthRole]},
    { path: 'pop-up', component: PopUpComponent,canActivate: [canActivateAuthRole]},
    { path: 'landing-page', component: LandingPageComponent,canActivate: [canActivateAuthRole],},
];
